
import React, { useState } from 'react';

import Grid from '@mui/material/Grid2';

import { 
  ModelBase, 
} from "@models";
import { 
  Resource,
  UpgradableNumber, 
} from "@dndModels";
import { REFRESH_RULES } from "@dndModels/Constants";

import API from "@dndUtilities/system_api";
import CommonUtilities from "@utilities/common_utilities";

import ModelBaseInput from "@dndComponents/ModelBaseInput";
import StringBox from "@components/input/strings/StringBox";
import SelectStringBox from "@components/input/selects/SelectStringBox";
import UpgradableNumberBox from "@dndComponents/UpgradableNumberBox";
import CheckBox from "@components/input/CheckBox";

const api = API.getInstance();
const common_util = CommonUtilities.getInstance();

interface Props {
  obj?: ModelBase;
}

export default function ResourceEdit({ obj: param_obj }: Props) {
  const [obj, setObj] = useState<Resource>(param_obj instanceof Resource ? param_obj : api.applyWorkingOn(new Resource()));
  const [change_time, setChangeTime] = useState(0);
  
  const disabled = api.user === null || !api.online || (!api.user.admin && obj._id !== "" && obj.owner_id !== api.user._id);
  
  return (
    <ModelBaseInput 
      obj={obj}
      disabled={disabled}
      change_time={change_time}
      onChange={(changed: ModelBase) => {
        if (changed instanceof Resource) {
          const new_obj = obj;
          new_obj.copy(changed);
          setObj(new_obj);
          setChangeTime(common_util.get_time_number());
        }
      }}>
      <Grid container spacing={0} direction="row">
        <Grid
          size={{
            xs: 12
          }}>
          <StringBox 
            value={obj.singular}
            name="Singular"
            onBlur={(changed: string) => {
              const new_obj = obj;
              new_obj.singular = changed;
              setObj(new_obj);
              setChangeTime(common_util.get_time_number());
            }}
          />
        </Grid>
        <Grid
          size={{
            xs: 12
          }}>
          <StringBox 
            value={`${obj.default_dice_size}`}
            name="Default Dice Size"
            type="number"
            onBlur={(changed: string) => {
              const new_obj = obj;
              new_obj.default_dice_size = +changed;
              setObj(new_obj);
              setChangeTime(common_util.get_time_number());
            }}
          />
        </Grid>
        <Grid
          size={{
            xs: 12
          }}>
          <SelectStringBox 
            options={REFRESH_RULES} 
            value={obj.refresh_rule}
            name="Refresh Rule"
            onChange={(changed: string) => {
              const new_obj = obj;
              new_obj.refresh_rule = changed;
              setObj(new_obj);
              setChangeTime(common_util.get_time_number());
            }}
          />
        </Grid>
        <Grid
          size={{
            xs: 12
          }}>
          <CheckBox 
            name="Zero on Rest"
            value={ obj.zero_on_rest }
            onChange={(changed: boolean) => {
              const new_obj = obj;
              new_obj.zero_on_rest = changed;
              setObj(new_obj);
              setChangeTime(common_util.get_time_number());
            }}
          />
        </Grid>
        { obj.refresh_rule === "Long Rest" &&
          <Grid
            size={{
              xs: 12
            }}>
            <UpgradableNumberBox  
              name="Refresh on Short Rest"
              value={obj.refresh_x_on_short}
              onChange={(changed: UpgradableNumber) => {
                const new_obj = obj;
                new_obj.refresh_x_on_short = changed.clone();
                setObj(new_obj);
                setChangeTime(common_util.get_time_number());
              }}
            />
          </Grid>
        }
      </Grid>
    </ModelBaseInput>
  ); 
}